import activity from './activity.pl.json';
import assets from './assets.pl.json';
import auth from './auth.pl.json';
import commissions from './commissions.pl.json';
import common from './common.pl.json';
import dashboard from './dashboard.pl.json';
import payouts from './payouts.pl.json';
import profile from './profile.pl.json';
import rewards from './rewards.pl.json';
import rewardsV3 from './rewardsV3.pl.json';
import shareLink from './shareLink.pl.json';
import stats from './stats.pl.json';
import transactions from './transactions.pl.json';

const pl = {
  activity,
  assets,
  auth,
  commissions,
  common,
  dashboard,
  payouts,
  profile,
  rewards,
  rewardsV3,
  shareLink,
  stats,
  transactions,
};

export default pl;
